import React, {useEffect, useState} from 'react'
import {Col, Form, FormCheck, FormGroup, FormLabel, Row} from 'react-bootstrap'
import Select from "react-select";
import {useForm} from "react-hook-form";
import {useHistory} from 'react-router-dom';
import {FadeLoader} from "react-spinners";
import {GetUsers} from "../../services/users.service";
import {CreatePushNotification} from "../../services/pushnotification.service";
import {toast} from "react-toastify";

function PushNotification(props) {

    const currentDate = new Date();
    currentDate.setHours(currentDate.getHours() + 1);
    let history = useHistory();
    const [users, setUsers] = useState([]);
    const [selectAllUsers, setSelectAllUsers] = useState(false);
    const [selectSelectedUsers, setSelectSelectedUsers] = useState(false); // Change to true
    const [loader, setLoader] = useState(false);
    const [selectedUser, setSelectedUser] = useState([])
    const { register, reset, setError, clearErrors, handleSubmit, formState: { errors } } = useForm({
        mode: "onBlur",
    });

    useEffect(() => {
        getUsers()
    }, [])

    const getUsers = async () => {
        await GetUsers(null, null, null, false).then((result) => {
            if (result.status && result.data.users) {
                setUsers(result.data.users);
            }
        })
    }

    const optionsUsers = (selectedSport) => {
        let data = [];
        selectedSport.map((item)=>{
            data.push(item.value)
        });
        setSelectedUser(data);
        clearErrors('users')
    }

    const onSubmit = async data => {
        if (!selectAllUsers && !selectSelectedUsers && selectedUser.length === 0) {
            setError("allUsers", {
                type: "manual",
                message: "Select at least one all users or selected user from checkboxes.",
            });
        } else {
            if (!selectAllUsers && selectedUser.length === 0) {
                setError("users", {
                    type: "manual",
                    message: "Select a user.",
                });
            }else{
                // Proceed with form submission
                let dt = {
                    title: data.title,
                    message: data.message,
                    users: selectedUser,
                };
                setLoader(true)
                await CreatePushNotification(dt).then(async (data) => {
                    setLoader(false)
                    if (data.status) {
                        toast.success(data.message);
                        reset({
                            message: '',
                        })
                        history.push('/push-notification-history');
                    } else {
                        setLoader(false)

                        toast.error(data.message);
                    }
                }).catch((error) => {
                    setLoader(false)
                    if (error.status == 401) {
                        // EmptyLocalStorage()
                        history.push('/');
                    }
                    else {
                        console.log(error);
                        return toast.error(error.response.data.message);
                    }
                })
            }

        }

    };

    const handleSelectAllUsersChange = (event) => {
        const isChecked = event.target.checked;
        if(isChecked){

            setSelectedUser([])
            setSelectAllUsers(true);
            setSelectSelectedUsers(false);
            clearErrors("allUsers");
            const allUsers = [];
            users.map((item)=>{
                allUsers.push(item._id)
            });
            setSelectedUser(allUsers)

        }

    };

    const handleSelectSelectedUsersChange = (event) => {
        const isChecked = event.target.checked;
        if(isChecked){
            setSelectedUser([])
            setSelectAllUsers(false);
            setSelectSelectedUsers(true);
            clearErrors("allUsers");
        }
    };



    return (
        <div className="AddNewUser">
            {/*<BreadcrumbsComponent />*/}
            <h3 className="page-heading">Push Notifications</h3>
            <hr />
            <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Form encType="multipart/form-data" className="formAddUser" autoComplete="off" role="presentation" onSubmit={handleSubmit(onSubmit)}>

                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label>Title*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Title"
                                        id={"formSignUpName"}
                                        maxLength={25}
                                        minLength={3}
                                        {...register('title', {
                                            required: {
                                                value: "required",
                                                message: "Title is required"
                                            },
                                            minLength: {
                                                value: 3,
                                                message: "Min length is 3"
                                            },
                                            maxLength: {
                                                value: 25,
                                                message: "Max length is 25"
                                            },
                                        })} type="text"
                                    />
                                    {errors.title && <Form.Text
                                        className="text-muted validationText hasError">{errors.title.message}</Form.Text>}

                                </Form.Group>
                            </Col>

                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <FormGroup className="checkbox-wrapper">
                                    <FormLabel>
                                        <FormCheck
                                            type="checkbox"
                                            checked={selectAllUsers}
                                            onChange={handleSelectAllUsersChange}
                                            label="All Users"
                                        />
                                    </FormLabel>
                                    <FormLabel>
                                        <FormCheck
                                            type="checkbox"
                                            checked={selectSelectedUsers}
                                            onChange={handleSelectSelectedUsersChange}
                                            label="Selected Users"
                                        />
                                    </FormLabel>
                                </FormGroup>
                            </Col>
                            {errors.allUsers && (
                                <div className="text-muted validationText hasError text-end">
                                    {errors.allUsers.message}
                                </div>
                            )}
                        </Row>

                        <Row>
                            {selectSelectedUsers && (
                                <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="users">
                                        <Form.Label className='d-block'>Select Users</Form.Label>
                                        <Select
                                            isMulti
                                            options={ users && users.map(e => ({ label: e.fullName, value: e._id}))}
                                            className="basic-multi-select"
                                            onChange={optionsUsers}
                                            classNamePrefix="select"
                                        />
                                        {errors.users && <Form.Text className="text-muted validationText hasError">{errors.users.message}</Form.Text>}
                                    </Form.Group>
                                </Col>
                            )}
                        </Row>

                        <Row>
                            <Col className="mb-3" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Group controlId="description">
                                    <Form.Label>Message*</Form.Label>
                                    <Form.Control as="textarea" rows={5} {...register('message', {
                                        required: {
                                            value: "required",
                                            message: "Message is required"
                                        },
                                        minLength: {
                                            value: 1,
                                            message: "Min length is 1"
                                        },
                                        maxLength: {
                                            value: 450,
                                            message: "Max length is 450"
                                        },
                                    })} />
                                    {errors.message && <Form.Text
                                        className="text-muted validationText hasError">{errors.message.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                                {loader ? <div className="spin-loader">
                                        <FadeLoader color={"#f39633"} height={10} />
                                    </div> :
                                    <input type={"submit"} className={"btn btn-green-theme w-100 mt-3"}
                                           value={"Push"} />}
                            </Col>


                        </Row>
                    </Form>

                </Col>
            </Row>

        </div>
    )
}

export default PushNotification
